import { z } from 'zod';

export const deleteCropRequestSchema = z.object({
  localPath: z.string(),
});

export type IDeleteCropRequest = z.infer<typeof deleteCropRequestSchema>;
